// Traduções do botão Ver rastro, coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'rastro.verNoMapa': 'Ver rastro',
    'rastro.verNoMapaDica': 'Ver no Mapa as transmissões desta ocorrência',
  },
  en: {
    'rastro.verNoMapa': 'View track',
    'rastro.verNoMapaDica': 'See this occurrence\'s transmissions on the Map',
  },
  es: {
    'rastro.verNoMapa': 'Ver rastro',
    'rastro.verNoMapaDica': 'Ver en el Mapa las transmisiones de esta ocurrencia',
  },
}
